module.exports = __webpack_public_path__ + "img/BLUE-PRINT.fc38630d.jpg";